module.exports = __webpack_public_path__ + "static/media/sr.f2fae2d0.svg";